import React from 'react';
import {
  Box,
  Button,
  Stack,
  Divider,
  Typography
} from '@mui/material';
import {
  Visibility as VisibilityIcon,
  ContentCopy as CopyIcon,
  Share as ShareIcon,
  Analytics as AnalyticsIcon,
  QrCode as QrCodeIcon
} from '@mui/icons-material';

const DrawerActions = ({ viewPublicProfile, copyPublicLink, onQRCodeClick }) => {
  return (
    <Box sx={{ p: 2, borderTop: '1px solid #e7e5e4' }}>
      <Stack spacing={1}>
        <Button
          fullWidth
          onClick={viewPublicProfile}
          sx={{
            justifyContent: 'flex-start',
            color: '#57534e',
            textTransform: 'none',
            py: 1,
            '&:hover': { bgcolor: '#f5f5f4' }
          }}
        >
          Voir ma fiche
        </Button>
        <Button
          fullWidth
          startIcon={<QrCodeIcon />}
          onClick={onQRCodeClick}
          sx={{
            justifyContent: 'flex-start',
            color: '#57534e',
            textTransform: 'none',
            py: 1,
            '&:hover': { bgcolor: '#f5f5f4' }
          }}
        >
          QR Code
        </Button>
        <Button
          fullWidth
          startIcon={<CopyIcon />}
          onClick={copyPublicLink}
          sx={{
            justifyContent: 'flex-start',
            color: '#57534e',
            textTransform: 'none',
            py: 1,
            '&:hover': { bgcolor: '#f5f5f4' }
          }}
        >
          Copier le lien
        </Button>
      </Stack>
    </Box>
  );
};

export default DrawerActions;
